import { combineReducers } from '@reduxjs/toolkit';
import notifications from 'notifications/store/NotificationSlice';
import security from 'feature/security/securitySlice';
import pto from 'feature/inventory-management/product-transfer-order/store';
import reconsignments from 'feature/inventory-management/reconsignments/store/reconsignmentsReducer';
import loadingManagement from 'feature/loading-management/loadingManagement.reducer';
import subscriptions from 'feature/subscription-plans/store/subscriptionsSlice';
import batches from 'feature/shipping/batches/store/batchesReducer';
import snackbar from 'snackbar/snackbarSlice';
import navigation from 'navigation/navigationSlice';
import authentication from 'authentication/authenticationSlice';
import confirmationDialog from 'store/Confirmationdialogslice';

// RTK Querys
import dispatchingApi from 'feature/dispatching/dispatchingApi';
import { loadingManagementApi } from 'feature/loading-management/loadingManagementApi';
import { inventoryManagementApi } from 'feature/inventory-management/inventoryManagementApi';
import shippingApi from 'feature/shipping/shippingApi';
import timsApi from 'feature/loading-management/terminal-information/terminal-locator/timsApi';
import subscriptionApi from 'feature/subscription-plans/subscriptionApi';
import { globalDataApi } from 'feature/global-data/globalDataApi';

export default combineReducers({
  [dispatchingApi.reducerPath]: dispatchingApi.reducer,
  [inventoryManagementApi.reducerPath]: inventoryManagementApi.reducer,
  [loadingManagementApi.reducerPath]: loadingManagementApi.reducer,
  [shippingApi.reducerPath]: shippingApi.reducer,
  [timsApi.reducerPath]: timsApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [globalDataApi.reducerPath]: globalDataApi.reducer,
  authentication,
  batches,
  confirmationDialog,
  loadingManagement,
  navigation,
  notifications,
  pto,
  reconsignments,
  security,
  snackbar,
  subscriptions,
});
